export default {"src":"/_next/static/media/scenario-development.d826657c.svg","height":216,"width":244,"blurWidth":0,"blurHeight":0};